import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import type { ResidentMedicationsResponse } from '../types'
import {
  RESIDENT_MEDICATIONS_QUERY_KEY,
  RESIDENT_MEDICATIONS_URL
} from './queryConstants'

type UseResidentMedicationsProps = {
  homeId: string
  residentId: string
  residentMedicationId?: string
}

type UseResidentMedicationsReturn = {
  data: ResidentMedicationsResponse | null
  isLoading: boolean
  refetch: () => void
}

export const useResidentMedications = ({
  homeId,
  residentId,
  residentMedicationId
}: UseResidentMedicationsProps): UseResidentMedicationsReturn => {
  const params = getQueryParams({
    homeId,
    residentId,
    ...(residentMedicationId && { residentMedicationId })
  })

  const { data, isLoading, refetch } = useQuery(
    [RESIDENT_MEDICATIONS_QUERY_KEY, params],
    () =>
      getJSON({
        url: `${RESIDENT_MEDICATIONS_URL}?${params}`
      }),
    {
      enabled: Boolean(homeId && residentId),
      retry: 1
    }
  )

  return {
    data: (data as ResidentMedicationsResponse) || null,
    isLoading,
    refetch
  }
}

export default useResidentMedications
